/**
 * ViewToggle — grid/list/map switch for the listings results area.
 *
 * Controlled component. Parent owns the `mode` state + persistence
 * (localStorage key is a parent concern so the same mode can be
 * applied on first render without a flash).
 */
import React from 'react';
import classNames from 'classnames';

import css from './ViewToggle.module.css';

const GridIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <rect x="14" y="14" width="7" height="7" rx="1" />
  </svg>
);

const ListIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="8" y1="6" x2="21" y2="6" />
    <line x1="8" y1="12" x2="21" y2="12" />
    <line x1="8" y1="18" x2="21" y2="18" />
    <circle cx="4" cy="6" r="1" />
    <circle cx="4" cy="12" r="1" />
    <circle cx="4" cy="18" r="1" />
  </svg>
);

const MapPinIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const ViewToggle = ({ mode, onChange }) => (
  <div className={css.root} role="group" aria-label="Vy">
    <button
      type="button"
      className={classNames(css.button, { [css.buttonActive]: mode === 'grid' })}
      onClick={() => onChange('grid')}
      aria-pressed={mode === 'grid'}
      aria-label="Rutnät"
      title="Rutnät"
    >
      <GridIcon />
    </button>
    <button
      type="button"
      className={classNames(css.button, { [css.buttonActive]: mode === 'list' })}
      onClick={() => onChange('list')}
      aria-pressed={mode === 'list'}
      aria-label="Lista"
      title="Lista"
    >
      <ListIcon />
    </button>
    <button
      type="button"
      className={classNames(css.button, { [css.buttonActive]: mode === 'map' })}
      onClick={() => onChange('map')}
      aria-pressed={mode === 'map'}
      aria-label="Karta"
      title="Karta"
    >
      <MapPinIcon />
    </button>
  </div>
);

export default ViewToggle;
